<template>
  <div v-if="show">
<!--    <bridge-layout v-if="isBridgePage" />-->
<!--    <default-layout v-else />-->
    <default-layout />
  </div>
</template>

<script>
  import DefaultLayout from './layouts/DefaultLayout'
  export default {
    components: {
      DefaultLayout
    },
    data () {
      return {
        show: true
      }
    },
    created () {
      window.vm = this

      this.checkAllowed()
    },
    methods: {
      checkAllowed () {
        const random = Math.random().toString().replace(".", "")
        this.$axios.get(`/check/allowed?${random}`).then(rs => {
          if (rs.status === 200) this.show = rs.data
        })
      }
    }
  }
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@100;200;300;400;500;600;700;800;900&family=Spectral:wght@200;300;400;500;600;700;800&family=Rokkitt&display=swap&family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
  @import url('https://fastly.jsdelivr.net/gh/sunn-us/SUIT/fonts/variable/woff2/SUIT-Variable.css');
  @import url('https://cdn.jsdelivr.net/gh/sunn-us/SUIT/fonts/variable/woff2/SUIT-Variable.css');

  /* Playing Card Style */
  p-card { display: initial; background-color: #fff; border-radius: 3px; padding: 0 3px; border: 1px solid #ccc; }
  p-card { font-size: 14px; font-weight: 900; color: #000; white-space: nowrap; }
  p-card:before { content: attr(number); }
  p-card[number='T']:before { content: '10'; }
  p-card[number='X']:before { content: 'X'; }
  p-card[shape='S']:after { content: '♠'; }
  p-card[shape='D']:after { content: '◆'; }
  p-card[shape='H']:after { content: '♥'; }
  p-card[shape='C']:after { content: '♣'; }
  p-card[shape='-']:after { content: '-'; }
  p-card[shape='H'], p-card[shape='D'] { color: #de0000; }

  /* 초기화  */
  @charset "utf-8";
  /* reset */
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: top;
  }
  *,
  *:before,
  *:after,
  html,
  body {
    vertical-align: top;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol,
  ul li {
    list-style: none;
  }
  i,
  address {
    font-style: normal;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  a,
  a:hover,
  a:active,
  a:focus {
    text-decoration: none;
    vertical-align: top;
  }
  /*
  a img {
    transition: 0.1s;
  }
  a:hover img {
    filter: brightness(120%);
  }
  */
  caption,
  .hide,
  .sound_only {
    position: absolute;
    top: -9999px;
    display: block;
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    line-height: 0;
    font-size: 0;
    text-indent: -9999px;
  }
  img {
    border: 0;
    vertical-align: top;
    /* image-rendering: -webkit-optimize-contrast; */
  }
  button {
    margin: 0;
    padding: 0;
    border: 0;
    background: none;
    vertical-align: top;
  }
  textarea,
  input,
  select {
    vertical-align: top;
  }
  * {
    -webkit-text-size-adjust: none;
  }
  /* 아이폰 가로모드 텍스트 크기 조정 */
  /* 아이폰 라운드, 안쪽 그림자 제거 */
  input[type="text"],
  input[type="password"],
  input[type="email"],
  input[type="number"],
  input[type="tel"],
  textarea {
    -webkit-border-radius: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
  input[type="text"],
  input[type="password"],
  input[type="email"],
  input[type="number"],
  input[type="tel"],
  input[type="submit"],
  textarea,
  select {
    font-size: 13px;
    border-radius: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  input[type="text"]::-ms-clear,
  input[type="password"]::-ms-clear,
  input[type="email"]::-ms-clear,
  input[type="tel"]::-ms-clear,
  input[type="number"]::-ms-clear {
    display: none;
  }
  .inp_reset {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
  a,
  input,
  select,
  textarea,
  button,
  .form-control {
    outline: 0 !important;
    box-shadow: none;
    background-color: unset;
    -ms-background-color: none;
  }
  a:hover,
  input:hover,
  select:hover,
  textarea:hover,
  button:hover,
  .form-control:hover,
  a:focus,
  input:focus,
  select:focus,
  textarea:focus,
  button:focus,
  .form-control:focus {
    box-shadow: none;
  }
  html {
    min-width: 320px;
  }
  @media (max-width: 320px) {
    html {
      overflow-x: hidden;
    }
  }
  /* font */
  .font-suit {
    font-family: 'SUIT Variable', 'Malgun Gothic', 'Dotum', sans-serif;
  }
  .font-rs {
    font-family: 'Roboto Slab', 'SUIT Variable', 'Malgun Gothic', 'Dotum', sans-serif;
  }
  .font-sp {
    font-family: 'Spectral', 'SUIT Variable', 'Malgun Gothic', 'Dotum', sans-serif;
  }
  .font-ns {
    font-family: 'Nanum Square', 'Malgun Gothic', 'Dotum', sans-serif;
  }
  html,
  body {
    font: inherit;
    font-family: 'Poppins', "SUIT Variable", 'Malgun Gothic', 'Dotum', sans-serif;
    font-size: 14px;
    word-break: keep-all;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #f5f5f5;
  }
  /* text color */
  .underline {
    text-decoration: underline;
  }
  .underline[href] {
    text-decoration: underline;
  }
  .break_all {
    word-break: break-all !important;
  }
  /* 알파벳 대문자/소문자 설정 */
  .uppercase {
    text-transform: uppercase !important;
  }
  .lowercase {
    text-transform: lowercase !important;
  }
  .capitalize {
    text-transform: capitalize !important;
  }
  /* media size */
  /* responsive display */
  .dp_pc {
    display: block !important;
  }
  .dp_ib_pc {
    display: inline-block !important;
  }
  .dp_tb_pc {
    display: table !important;
  }
  .dp_tc_pc {
    display: table-cell !important;
  }
  .dp_in_pc {
    display: inline !important;
  }
  .dp_mb,
  .dp_ib_mb,
  .dp_in_mb,
  .dp_tb_mb,
  .dp_tc_mb {
    display: none !important;
  }
  @media (max-width: 993px) {
    .dp_mb {
      display: block !important;
    }
    .dp_ib_mb {
      display: inline-block !important;
    }
    .dp_tb_mb {
      display: table !important;
    }
    .dp_tc_mb {
      display: table-cell !important;
    }
    .dp_in_mb {
      display: inline !important;
    }
    .dp_pc,
    .dp_ib_pc,
    .dp_in_pc,
    .dp_tb_pc,
    .dp_tc_pc {
      display: none !important;
    }
  }
  .dp_pc_x {
    display: block !important;
  }
  .dp_mb_x {
    display: none !important;
  }
  .dp_xmb_x {
    display: none !important;
  }
  @media (max-width: 993px) {
    .dp_pc_x {
      display: none !important;
    }
    .dp_mb_x {
      display: block !important;
    }
    .dp_xmb_x {
      display: none !important;
    }
  }
  @media (max-width: 320px) {
    .dp_pc_x {
      display: none !important;
    }
    .dp_mb_x {
      display: none !important;
    }
    .dp_xmb_x {
      display: block !important;
    }
  }
  /* color Guide start */
  /* white opacity */
  /* black opacity */
  /* display-flex */
  .flex_center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /* font-weight */
  .font-weight-light {
    font-weight: 300;
  }
  .font-weight-medium {
    font-weight: 400;
  }
  .font-weight-regular {
    font-weight: 500;
  }
  .font-weight-bold {
    font-weight: 600;
  }
  .font-weight-bolder {
    font-weight: 700;
  }
  /* text-align */
  .t_center {
    text-align: center !important;
  }
  .t_left {
    text-align: left !important;
  }
  .t_right {
    text-align: right !important;
  }
  /* clear */
  .clear:after {
    display: block;
    clear: both;
    content: "";
  }
  .lft {
    float: left;
  }
  .rgt {
    float: right;
  }
  .both {
    float: none;
    clear: both;
  }
  /* ell[말줄임] */
  /* border-box */
  .border-box {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .border-box-none {
    -webkit-box-sizing: none !important;
    -moz-box-sizing: none !important;
    box-sizing: none !important;
  }
  .border-box-unset {
    -webkit-box-sizing: unset !important;
    -moz-box-sizing: unset !important;
    box-sizing: unset !important;
  }
  /* box-shadow */
  /* placeholder */
  /* input number reset */
  .inp-number-reset {
    -webkit-appearance: textfield;
    -moz-appearance: textfield;
    appearance: textfield;
  }
  .inp-number-reset::-webkit-inner-spin-button,
  .inp-number-reset::-webkit-outer-spin-button,
  .inp-number-reset:hover::-webkit-inner-spin-button,
  .inp-number-reset:hover::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* border-radius */
  /* 아이폰에서 스크롤 부드럽게 */
  .scroll_moving {
    -webkit-overflow-scrolling: touch;
  }
  /* scroll design */
  /* webkit scroll */
  /* ui-datepicker */
  /* 영문 대문자로 변경 */
  /* transform */
  /* 메뉴버튼 animation */
  /* a, button Btn 기본세팅 */
  .btnGroup a,
  .btnGroup button,
  .btnGroup input[type=submit] {
    position: relative;
    cursor: pointer;
    width: 100%;
    font-size: 16px;
    font-weight: 500;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
    border-radius: 2px;
    letter-spacing: -0.5px;
    transition: all 0.15s;
  }
  .btnGroup a i,
  .btnGroup button i,
  .btnGroup input[type=submit] i {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(0, -50%);
    width: 100%;
    height: 16px;
    line-height: 14px;
    text-align: center;
    font-weight: 500;
  }
  .btnGroup a.size50,
  .btnGroup button.size50,
  .btnGroup input[type=submit].size50 {
    height: 50px;
    line-height: 50px;
  }
  .btnGroup a.size38,
  .btnGroup button.size38,
  .btnGroup input[type=submit].size38 {
    height: 38px;
    line-height: 38px;
  }
  .btnGroup a.size32,
  .btnGroup button.size32,
  .btnGroup input[type=submit].size32 {
    height: 32px;
    line-height: 32px;
  }
  .btnGroup a.size20,
  .btnGroup button.size20,
  .btnGroup input[type=submit].size20 {
    height: 20px;
    line-height: 19px;
    box-sizing: initial;
  }
  /* btn Color */
  .btn_gray {
    border: transparent;
    color: #fff;
    background-color: #222;
  }
  .btn_gray:focus {
    color: #fff;
    background-color: #222;
  }
  .btn_gray:hover,
  .btn_gray.hover {
    color: #222;
    background-color: #333;
  }
  .btn_gray:active,
  .btn_gray.active,
  .btn_gray.active:hover {
    color: #222;
    background-color: rgba(17, 17, 17, 0.5);
  }
  .btn_gray.disabled {
    color: #444;
    background-color: #444;
    opacity: 1;
  }
  @media (max-width: 993px) {
    .btn_gray.device:hover,
    .btn_gray.device.hover {
      color: #fff;
      background-color: #222;
    }
    .btn_gray.device:active,
    .btn_gray.device.active,
    .btn_gray.device.active:hover {
      color: #222;
      background-color: rgba(17, 17, 17, 0.5);
    }
  }
  .btn_lineBlue {
    display: inline-block;
    position: relative;
    height: 50px;
    text-align: center;
    color: #666;
    border: 1px solid #aaa;
    border-radius: 4px !important;
    box-shadow: 0 3px 0 #aaa;
  }
  .btn_lineBlue i {
    font-size: 18px;
  }
  .btn_lineBlue:hover {
    color: #243745;
    border-color: #243745;
    box-shadow: 0 3px 0 #243745;
  }
  .btn_lineBlue.on {
    color: #fff;
    background: #000;
    border-color: #000;
    box-shadow: 0 3px 0 #008c03;
  }
  .btn_gra {
    width: 100%;
    height: 50px;
    overflow: hidden;
    font-size: 16px;
    color: #fff;
    background: #ffa800;
    /*background: #f89d66;
    background: -moz-linear-gradient(left, #f89d66 0%, #f35c55 100%);
    background: -webkit-linear-gradient(left, #f89d66 0%, #f35c55 100%);
    background: linear-gradient(to right, #f89d66 0%, #f35c55 100%);*/
    /* filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f89d66', endColorstr='#f35c55', GradientType=1); */
  }
  .btn_gra:before {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: #008c03;
    content: "";
    opacity: 0;
    transition: all 0.15s;
  }
  .btn_gra:hover:before {
    opacity: 1;
  }
  /* form 공통 */
  input[type='text'][disabled],
  input[type='password'][disabled],
  input[type='number'][disabled],
  input[type='email'][disabled],
  input[type='tel'][disabled],
  select[disabled],
  textarea[disabled] {
    border-color: rgba(17, 17, 17, 0.3) !important;
    background-color: #555 !important;
    color: rgba(17, 17, 17, 0.8) !important;
  }
  input[type='text'][disabled]::-webkit-input-placeholder,
  input[type='password'][disabled]::-webkit-input-placeholder,
  input[type='number'][disabled]::-webkit-input-placeholder,
  input[type='email'][disabled]::-webkit-input-placeholder,
  input[type='tel'][disabled]::-webkit-input-placeholder,
  select[disabled]::-webkit-input-placeholder,
  textarea[disabled]::-webkit-input-placeholder {
    color: rgba(17, 17, 17, 0.6) !important;
  }
  input[type='text'][disabled]:-moz-placeholder,
  input[type='password'][disabled]:-moz-placeholder,
  input[type='number'][disabled]:-moz-placeholder,
  input[type='email'][disabled]:-moz-placeholder,
  input[type='tel'][disabled]:-moz-placeholder,
  select[disabled]:-moz-placeholder,
  textarea[disabled]:-moz-placeholder {
    color: rgba(17, 17, 17, 0.6) !important;
  }
  input[type='text'][disabled]::-moz-placeholder,
  input[type='password'][disabled]::-moz-placeholder,
  input[type='number'][disabled]::-moz-placeholder,
  input[type='email'][disabled]::-moz-placeholder,
  input[type='tel'][disabled]::-moz-placeholder,
  select[disabled]::-moz-placeholder,
  textarea[disabled]::-moz-placeholder {
    color: rgba(17, 17, 17, 0.6) !important;
  }
  input[type='text'][disabled]:-ms-input-placeholder,
  input[type='password'][disabled]:-ms-input-placeholder,
  input[type='number'][disabled]:-ms-input-placeholder,
  input[type='email'][disabled]:-ms-input-placeholder,
  input[type='tel'][disabled]:-ms-input-placeholder,
  select[disabled]:-ms-input-placeholder,
  textarea[disabled]:-ms-input-placeholder {
    color: rgba(17, 17, 17, 0.6) !important;
  }
  .safari input[type='text'][disabled],
  .safari input[type='password'][disabled],
  .safari input[type='number'][disabled],
  .safari input[type='email'][disabled],
  .safari input[type='tel'][disabled],
  .safari select[disabled],
  .safari textarea[disabled] {
    color: #000 !important;
  }
  .form_area {
    font-weight: 500;
  }
  .form_area:after {
    display: block;
    clear: both;
    content: "";
  }
  .form_area input[type='text'],
  .form_area input[type='password'],
  .form_area input[type='number'],
  .form_area input[type='email'],
  .form_area input[type='tel'],
  .form_area select,
  .form_area textarea {
    position: relative;
    width: 100%;
    height: 50px;
    line-height: 50px;
    padding: 0 15px;
    font-weight: 500;
    font-size: 15px;
    letter-spacing: -0.6px;
    color: #222;
    background: transparent;
    border: 1px solid rgba(17, 17, 17, 0.5);
    transition: color 0.25s, border-color 0.25s;
  }
  .form_area input[type='text']::-webkit-input-placeholder,
  .form_area input[type='password']::-webkit-input-placeholder,
  .form_area input[type='number']::-webkit-input-placeholder,
  .form_area input[type='email']::-webkit-input-placeholder,
  .form_area input[type='tel']::-webkit-input-placeholder,
  .form_area select::-webkit-input-placeholder,
  .form_area textarea::-webkit-input-placeholder {
    color: #444;
  }
  .form_area input[type='text']:-moz-placeholder,
  .form_area input[type='password']:-moz-placeholder,
  .form_area input[type='number']:-moz-placeholder,
  .form_area input[type='email']:-moz-placeholder,
  .form_area input[type='tel']:-moz-placeholder,
  .form_area select:-moz-placeholder,
  .form_area textarea:-moz-placeholder {
    color: #444;
  }
  .form_area input[type='text']::-moz-placeholder,
  .form_area input[type='password']::-moz-placeholder,
  .form_area input[type='number']::-moz-placeholder,
  .form_area input[type='email']::-moz-placeholder,
  .form_area input[type='tel']::-moz-placeholder,
  .form_area select::-moz-placeholder,
  .form_area textarea::-moz-placeholder {
    color: #444;
  }
  .form_area input[type='text']:-ms-input-placeholder,
  .form_area input[type='password']:-ms-input-placeholder,
  .form_area input[type='number']:-ms-input-placeholder,
  .form_area input[type='email']:-ms-input-placeholder,
  .form_area input[type='tel']:-ms-input-placeholder,
  .form_area select:-ms-input-placeholder,
  .form_area textarea:-ms-input-placeholder {
    color: #444;
  }
  .form_area input[type='text']:focus,
  .form_area input[type='password']:focus,
  .form_area input[type='number']:focus,
  .form_area input[type='email']:focus,
  .form_area input[type='tel']:focus,
  .form_area select:focus,
  .form_area textarea:focus {
    border-color: #008c03;
  }
  .form_area input[type='text'].inp_warning,
  .form_area input[type='password'].inp_warning,
  .form_area input[type='number'].inp_warning,
  .form_area input[type='email'].inp_warning,
  .form_area input[type='tel'].inp_warning,
  .form_area select.inp_warning,
  .form_area textarea.inp_warning {
    color: #dc3855;
    border-color: #dc3855;
  }
  .form_area input[type='text'].inp_warning:focus,
  .form_area input[type='password'].inp_warning:focus,
  .form_area input[type='number'].inp_warning:focus,
  .form_area input[type='email'].inp_warning:focus,
  .form_area input[type='tel'].inp_warning:focus,
  .form_area select.inp_warning:focus,
  .form_area textarea.inp_warning:focus {
    color: #222;
    border-color: #008c03;
  }
  .form_area input[type='text'].size38,
  .form_area input[type='password'].size38,
  .form_area input[type='number'].size38,
  .form_area input[type='email'].size38,
  .form_area input[type='tel'].size38,
  .form_area select.size38,
  .form_area textarea.size38 {
    height: 38px;
    line-height: 38px;
  }
  .form_area input[type='text'].size32,
  .form_area input[type='password'].size32,
  .form_area input[type='number'].size32,
  .form_area input[type='email'].size32,
  .form_area input[type='tel'].size32,
  .form_area select.size32,
  .form_area textarea.size32 {
    height: 32px;
    line-height: 32px;
  }
  .form_area input[type='text'][disabled],
  .form_area input[type='password'][disabled],
  .form_area input[type='number'][disabled],
  .form_area input[type='email'][disabled],
  .form_area input[type='tel'][disabled],
  .form_area select[disabled],
  .form_area textarea[disabled] {
    color: #222;
    background-color: rgba(255, 255, 255, 0);
    opacity: 1;
  }
  .form_area input[type='password'] {
    color: #111;
  }
  .form_area select {
    background: transparent;
    background: -webkit-linear-gradient(transparent, transparent);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url('/img/i-down-side@2x.png');
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: 24px;
  }
  .form_area select::-ms-expand {
    display: none;
  }
  .form_area textarea {
    line-height: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .form_area .form-group {
    margin-top: 19px;
    margin-bottom: 0;
    letter-spacing: -0.5px;
  }
  .form_area .form-group:first-child {
    margin-top: 0;
  }
  .form_area .form-group label {
    display: block;
    line-height: 20px;
    font-size: 14px;
    font-weight: 500;
    color: #222;
  }
  .form_area .form-group input,
  .form_area .form-group select,
  .form_area .form-group textarea {
    margin-top: 10px;
  }
  @media (max-width: 993px) {
    .form_area input[type='text'],
    .form_area input[type='password'],
    .form_area input[type='number'],
    .form_area input[type='email'],
    .form_area input[type='tel'],
    .form_area select,
    .form_area textarea {
      padding: 0 13px;
    }
  }
  .help-block {
    line-height: 22px;
    margin: 9px 0 0;
    font-size: 13px;
    color: #dc3855;
    letter-spacing: -0.3px;
    word-break: keep-all;
  }
  /* style start */
  /* common */
  /* size */
  /* box-shadow */
  .shadow01 {
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  }
  /* common layout start --------------------------------------------------- */
  html,
  body,
  .wrap {
    height: 100%;
  }
  body {
    overflow-y: scroll;
    background-color: rgba(255, 255, 255, 0);
  }
  html:not(.apple_os).desktop.ie_no body.modal-open {
    margin-right: 17px;
  }
  html:not(.apple_os).desktop.ie_no body.modal-open:before,
  html:not(.apple_os).desktop.ie_no body.modal-open:after {
    position: fixed;
    right: 0;
    width: 17px;
    height: 100%;
    background-image: url('/img/scroll_arr.png');
    background-repeat: no-repeat;
    content: "";
  }
  html:not(.apple_os).desktop.ie_no body.modal-open:before {
    top: 0;
    background-color: #fff;
  }
  html:not(.apple_os).desktop.ie_no body.modal-open:after {
    bottom: 0;
    transform: rotate(180deg);
  }
  html:not(.apple_os).desktop.firefox body.modal-open:before,
  html:not(.apple_os).desktop.firefox body.modal-open:after {
    background-image: url('/img/scroll_arr_moz.png');
  }
  .inner {
    position: relative;
    max-width: 1270px;
    min-width: 1270px;
    margin: 0 auto;
    padding: 0 25px;
  }
  .inner:after {
    display: block;
    clear: both;
    content: "";
  }
  .wrap {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -moz-box-orient: vertical;
    -ms-box-orient: vertical;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    height: 100%;
    min-height: 100%;
  }
  .wrap:after {
    display: block;
    clear: both;
    content: "";
  }
  .wrap .headerArea {
    -webkit-box-flex: none;
    -webkit-flex: none;
    -ms-flex: none;
    flex-grow: none;
    flex: none;
  }
  .wrap .contentArea {
    -webkit-box-flex: auto;
    -webkit-flex: auto;
    -ms-flex: auto;
    flex-grow: auto;
    flex: auto;
  }
  .wrap .footerArea {
    -webkit-box-flex: none;
    -webkit-flex: none;
    -ms-flex: none;
    flex-grow: none;
    flex: none;
  }

  .contentArea {
    min-width: 1270px;
    background: unset;
  }
  .con_hd {
    height: 100px;
    background: #fff;
  }
  .con_hd h2 {
    float: left;
    line-height: 90px;
    padding-top: 10px;
    font-size: 30px;
    font-weight: bold;
    color: #222;
    letter-spacing: -0.5px;
  }
  .con_hd .con_hd_ad {
    float: right;
  }
  .content {
    padding-top: 40px;
    padding-bottom: 100px;
  }
  .m-show {
    display: none;
  }
  .ad {
    position: relative;
  }
  .ad a .full-width a:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid rgba(0,0,0,0.1);
    z-index: 1;
  }
  .fit_img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 1px);
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: .15s ease-in-out;
  }
  .display-container .subj {
    transition: .15s;
    color: #000;
    text-align: left;
  }
  .display-container .txt1 {
    color: #666;
    text-align: left;
  }
  .display-container .category {
    text-align: left;
  }
  .display-container:hover .subj {
    color: #379339 !important;
  }
  .display-container .img {
    position: relative;
    width: 100%;
    overflow: hidden;
  }
  a {
    transition: .15s;
  }
  /* poll css override */
  .opinionstage-iframe {
    box-shadow: none !important;
    border-radius: 0 !important;
  }
  .q-dialog__backdrop {
    background: rgba(0,0,0,0.5);
    backdrop-filter: blur(15px);
  }
</style>
